module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/down-left-d52ab26c00c3a8e0a8462e52f4198a3d.svg";